/**
 * Enum representing the status of a test flow execution.
 */
export enum TestFlowStatus {
  IDLE = 'IDLE',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
